import React from 'react';
import PropTypes from 'prop-types';
import Skeleton from 'react-loading-skeleton';

export default function Merchant(props) {
  const {
    display, result, target, styles, url, containerClassName,
  } = props;
  const isLoaded = !!result;
  const name = isLoaded ? result?.strMerchantName?.replace(/&amp;/gi, '&') : '';
  const content = url
    ? (
      <a href={url} target={target} rel="noopener noreferrer" style={styles.merchantLink}>
        {name}
      </a>
    )
    : name;

  if (display) {
    return (
      <div style={styles.merchantContainer} className={containerClassName}>
        {isLoaded ? content : <Skeleton style={{ width: 200 }} />}
      </div>
    );
  }
  return null;
}

Merchant.propTypes = {
  display: PropTypes.bool,
  target: PropTypes.string,
  result: PropTypes.shape({
    strMerchantName: PropTypes.string,
  }),
  styles: PropTypes.shape({
    merchantLink: PropTypes.shape({}),
    merchantContainer: PropTypes.shape({}),
  }),
  url: PropTypes.string,
  containerClassName: PropTypes.string,
};

Merchant.defaultProps = {
  display: true,
  result: null,
  target: '_blank',
  styles: {},
  url: null,
  containerClassName: null,
};
